export const FIRSTSUBHEADER = 'firstHeader' as const
export const SECONDSUBHEADER = 'secondHeader' as const

export const DIFFERENCE = 'difference' as const

export const DIFFERENCE_HEADER = '% 𝚫'

export const EXACT_TEXT_FILTER_TYPE = 'exactText'
